import { useQuery } from "@apollo/client";
import { useRouter } from "Hooks/useRouter";
import { queryParamsToProps, goToReportPage } from "../services/queryParams";
import queries from "Shared/queries";
import {
  GetBalanceDistributorReportQuery,
  GetBalanceDistributorReportQueryVariables
} from "generated/graphql";

const ROWS_PER_REPORT_PAGE = 10;

export const useBalanceDistributor = () => {
  const { history, location } = useRouter();
  const queryParams = queryParamsToProps(location.search);
  const { page } = queryParams;

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => goToReportPage(history, { page: newPage });


  const { data, loading, error } = useQuery<GetBalanceDistributorReportQuery, GetBalanceDistributorReportQueryVariables>(
    queries.GET_BALANCE_DISTRIBUTOR_REPORT, {
      variables: {
        page,
        perPage: ROWS_PER_REPORT_PAGE,
      },
    }
  );

  return {
    data: data?.employer.currentProvider.employeesEnrolledInPayrollExtender,
    loading,
    error,
    onChangePage,
    page,
  };
};
